import { render, staticRenderFns } from "./GroupSubHeader.vue?vue&type=template&id=65fe82d4&scoped=true&"
import script from "./GroupSubHeader.vue?vue&type=script&lang=js&"
export * from "./GroupSubHeader.vue?vue&type=script&lang=js&"
import style0 from "./GroupSubHeader.vue?vue&type=style&index=0&id=65fe82d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fe82d4",
  null
  
)

export default component.exports